import { render } from "./itemScroll.vue?vue&type=template&id=cf68feca"
import script from "./itemScroll.vue?vue&type=script&lang=js"
export * from "./itemScroll.vue?vue&type=script&lang=js"

import "./itemScroll.vue?vue&type=style&index=0&id=cf68feca&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__